/*
 * Views for the List region of the substitutions page
 */

define([
  "marionette",
  "highcharts/highcharts",
  "modules/reportSplit/reports/singleReport/template/singleReportTemplate.html",
], function (Marionette, Highcharts, SingleReportTemplate) {
  "use strict";

  const SingleReportView = {};

  SingleReportView.reportLayout = Marionette.Layout.extend({
    template: SingleReportTemplate,
    className: "max-height",
    regions: {
      chart: ".singleReport",
    },
    createChart: function (options) {
      return new Highcharts.Chart(this.$el[0], options);
    },
  });

  return SingleReportView;
});
